import {
  Calendar,
  CalendarGold,
  MyHub,
  MyHubGold,
  MySidebar,
  MySidebarGold,
  QuickLinks,
  QuickLinksGold,
} from '@ice-web-app/assets';
import { DsTypography } from '@ice-web-app/designSystem';
import { TIPS } from '@ice-web-app/shared-constants';
import { useTranslation } from '@ice-web-app/shared-hooks';
import { CircleGoldBorder } from '@ice-web-app/shared-ui';
import { getCurrentEcosystemBasePath } from '@ice-web-app/shared-utils';
import { Stack } from '@mui/material';
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import MiniNavbarLinkMenu from './MiniNavbarLinkMenu';

const MiniNavbarLinks = () => {
  const { t } = useTranslation();
  const [_activeLink, setActiveLink] = useState<'MY_HUB' | 'QUICK_LINKS' | 'MY_SIDEBAR' | 'CALENDAR'>();
  const [_openCalendarDrawer, setOpenCalendarDrawer] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const location = useLocation();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const ecosystem = getCurrentEcosystemBasePath();

  const LINKS = [
    {
      key: 'MY_HUB',
      icon: <MyHub />,
      activeIcon: <MyHubGold />,
      text: t('MY_HUB'),
      isActive: location.pathname.includes(`${ecosystem}/my-hub`),
      onClick: () => setActiveLink('MY_HUB'),
      'data-tour': TIPS.LAYOUT.SIDEBAR.MINI_SIDEBAR_INNOVATION_MY_HUB.DATA,
      to: `${ecosystem}/my-hub`,
    },
    {
      key: 'MY_SIDEBAR',
      icon: <MySidebar />,
      activeIcon: <MySidebarGold />,
      isActive: localStorage.getItem('MY_SIDEBAR') === 'true',
      text: t('MY_SIDEBAR'),
      onClick: () => {
        if (localStorage.getItem('MY_SIDEBAR') === 'true') {
          localStorage.setItem('MY_SIDEBAR', 'false');
        } else {
          localStorage.setItem('MY_SIDEBAR', 'true');
        }
      },
    },
    {
      key: 'QUICK_LINKS',
      icon: <QuickLinks />,
      activeIcon: <QuickLinksGold />,
      isActive: Boolean(anchorEl),
      text: t('QUICK_LINKS'),
      onClick: (e) => {
        handleClick(e);
      },
    },
    {
      key: 'CALENDAR',
      icon: <Calendar />,
      activeIcon: <CalendarGold />,
      text: t('CALENDAR'),
      onClick: () => {
        setActiveLink('CALENDAR');
        setOpenCalendarDrawer(true);
      },
    },
  ];

  return (
    <Stack alignItems="center" spacing={4} data-tour={TIPS.LAYOUT.SIDEBAR.MINI_SIDEBAR_BOTTOM_SECTION.DATA}>
      {LINKS.map((link) => (
        <Link to={link.to || '#'} key={link.key} onClick={link.onClick} data-tour={link['data-tour']}>
          <Stack justifyContent="center" alignItems="center" gap={1}>
            <CircleGoldBorder isActive={link.isActive}>{link.isActive ? link.activeIcon : link.icon}</CircleGoldBorder>
            <DsTypography variant="body2_500" sx={{ fontSize: '10px', textAlign: 'center', lineHeight: '16px' }}>
              {link.text}
            </DsTypography>
          </Stack>
        </Link>
      ))}

      <MiniNavbarLinkMenu anchorEl={anchorEl} setAnchorEl={setAnchorEl} />
    </Stack>
  );
};
export default MiniNavbarLinks;
